module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_ryiso@2x.06e50bb5.png";